import React, { Component } from "react";
// import axios from "axios";
import _ from "lodash";
import staticHomeData from "./HomeValue";
import HomeValueImage from "../../assets/images/hvalue_new.jpg";
import HomeIncomeImage from "../../assets/images/hincome_new.jpg";
import Person from "../dialogs/person";
import api from "../../api";
import settings from "../../settings";

class HomeValueAndIncomeComponent extends Component {
  state = {
    dialogProps: {
      title: "",
      imageUrl: "",
      tableHeader: "",
      address: "",
      zip: "",
      state: "",
      dataLabel: "",
      data: "",
      note: "",
      homeType: "",
    },
    homeData: [],
    loading: false,
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.state.dialogProps.zip !== nextProps.zip ||
      this.state.dialogProps.address !== nextProps.address
    ) {
      this.setHomeDialogProps(
        nextProps.zip,
        nextProps.address,
        nextProps.homeType
      );
    } else if (this.state.dialogProps.homeType !== nextProps.homeType) {
      const { dialogProps } = this.state;
      dialogProps.homeType = nextProps.homeType;
      this.setState({ dialogProps });
    }
  }

  setHomeDialogProps = (zip, address, homeType) => {
    if (zip === undefined || address === undefined || homeType === "") {
      return;
    }
    const homeDataKey = `${zip}_${address.replace(" ", "_")} `;
    const existingHomeData = this.state.homeData[homeDataKey];
    const title =
      homeType === "value"
        ? staticHomeData.homeValue.title
        : staticHomeData.homeIncome.title;
    const tableHeader =
      homeType === "value"
        ? staticHomeData.homeValue.tableHeader
        : staticHomeData.homeIncome.tableHeader;
    const note =
      homeType === "value"
        ? staticHomeData.homeValue.note
        : staticHomeData.homeIncome.note;
    const dataNodeName =
      homeType === "value"
        ? "Home_Value_Code_Description"
        : "Income_Estimated_Household_Ranges_Description";
    const imageUrl = homeType === "value" ? HomeValueImage : HomeIncomeImage;
    if (existingHomeData === undefined) {
      this.setState({ loading: true });
      api.lp
        .homeValueAndIncome({
          zipcode: zip,
          address,
          appName: settings.appName,
        })
        .then((res) => {
          const rp = _.get(
            res.data,
            "Data.response.responseDocumentsElement[0]"
          );
          const homeDialog = {
            title,
            imageUrl,
            tableHeader,
            address,
            zip,
            city: _.get(rp, "city", ""),
            state: _.get(rp, "state", ""),
            dataLabel: `${title}`,
            data: _.get(rp, dataNodeName, ""),
            homeType,
            note,
          };

          const newHomeDataArray = this.state.homeData;
          newHomeDataArray[homeDataKey] = rp;
          this.setState({
            dialogProps: homeDialog,
            showDialog: true,
            homeData: newHomeDataArray,
            loading: false,
          });
        });
    } else {
      const rp = this.state.homeData[homeDataKey];
      const homeDialog = {
        title,
        imageUrl,
        tableHeader,
        address,
        zip: _.get(rp, "zip", ""),
        city: _.get(rp, "city", ""),
        state: _.get(rp, "state", ""),
        dataLabel: `${title}`,
        data: _.get(rp, dataNodeName, ""),
        note,
      };
      this.setState({ dialogProps: homeDialog, showDialog: true });
    }
  };

  render() {
    const { dialogProps } = this.state;
    const homeDataKey =
      dialogProps && dialogProps.zip && dialogProps.address
        ? `${dialogProps.zip}_${dialogProps.address.replace(" ", "_")} `
        : "";
    const rp = this.state.homeData[homeDataKey];
    if (dialogProps.homeType === "value") {
      dialogProps.title = staticHomeData.homeValue.title;
      dialogProps.dataLabel = `${dialogProps.title}`;
      dialogProps.imageUrl = HomeValueImage;
      dialogProps.tableHeader = staticHomeData.homeValue.tableHeader;
      dialogProps.note = staticHomeData.homeValue.note;
      if (Object.keys(this.state.homeData).length > 0 && rp)
        dialogProps.data = _.get(rp, "Home_Value_Code_Description", "");
    } else {
      dialogProps.title = staticHomeData.homeIncome.title;
      dialogProps.dataLabel = `${dialogProps.title}`;
      dialogProps.imageUrl = HomeIncomeImage;
      dialogProps.tableHeader = staticHomeData.homeIncome.tableHeader;
      dialogProps.note = staticHomeData.homeIncome.note;
      if (Object.keys(this.state.homeData).length > 0 && rp)
        dialogProps.data = _.get(
          rp,
          "Income_Estimated_Household_Ranges_Description",
          ""
        );
    }
    return (
      <Person
        key="person_dialog_1"
        dialogProps={dialogProps}
        active={this.props.showDialog}
        dialogClose={this.props.handleHomeValueClose}
        loading={this.state.loading}
      />
    );
  }
}

export default HomeValueAndIncomeComponent;



// WEBPACK FOOTER //
// ./src/components/common/HomeValueAndIncomeComponent.js